import React, { Component } from 'react';
import InfoForm from '../../../../components/SiteAdmin/ShopHomepageSettings/InfoForm';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import getAllPartnerHomepage from './getAllPartnerHomepage.graphql';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './InfoSettings.css';
import Loader from '../../../../components/Common/Loader/Loader';


export class InfoSettings extends Component {

    static defaultProps = {
        data: {
            loading: true
        }
    }
    render() {
        const { data: { loading, getAllPartnerHomepage } } = this.props;
        let initialValues = {};
        let homepageCollection = {};

        getAllPartnerHomepage && getAllPartnerHomepage.homePageData.map((item) => {
            homepageCollection[item.name] = item.value
        })

        return (
            <div>
                <Loader type={"page"} show={loading}>
                    {!loading && <InfoForm initialValues={homepageCollection} />}
                </Loader>
            </div>
        )
    }
}

export default compose(
    withStyles(s),
    graphql(getAllPartnerHomepage, {
        options: (props) => ({
            fetchPolicy: 'network-only',
            ssr: false
        })
    })
)(InfoSettings)
